export default __webpack_public_path__ + "static/media/sso_linkedin.bcd5f15f.svg";